export default __webpack_public_path__ + "static/media/fundo-dinheiro.a204543c.svg";